var map = {
	"./Saqib.png": 3460,
	"./bloctech1.png": 374,
	"./bloctech2.png": 3441,
	"./bloctech3.jpg": 1702,
	"./buld.jpg": 8543,
	"./cisco.png": 6032,
	"./dal.png": 6288,
	"./devStrigs.png": 4747,
	"./ga.png": 4706,
	"./gamica.png": 7909,
	"./gamicas.png": 9050,
	"./google_logo.png": 5927,
	"./md.png": 1816,
	"./rescue.png": 4787,
	"./sal.png": 5693,
	"./simt.png": 863,
	"./simts.jpg": 7904,
	"./smit.png": 4430,
	"./vif.png": 3939,
	"./vifr.png": 4757,
	"./viftech.jpg": 8106,
	"./vjt.png": 7115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;